import React from 'react'

const SuiviStatutM = () => {
  return (
    <div>SuiviStatutM</div>
  )
}

export default SuiviStatutM